import { Component, input } from '@angular/core';

@Component({
  selector: 'procure-resize-handler',
  template: '',
  styleUrl: './resize-handler.component.scss',
  host: {
    '[class]': 'placement()',
  },
})
export class ResizeHandler {
  readonly placement = input.required<'left' | 'right'>();
}
